import React from 'react';
import { GridContainer } from './styles';

const DayaxeInstaWidget = () => (
  <GridContainer>
    <iframe src="https://snapwidget.com/embed/493276" title=";a;a;" className="snapwidget-widget" frameBorder="0" scrolling="no" style={{ width: '100%', overflow: 'hidden'}} />
  </GridContainer>
);

export default DayaxeInstaWidget;
